var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallOrangeArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.995 2.68l-1.087 1.03L8.484 14.53l-1.03.975-1.032-.975L1.087 9.48 0 8.45l2.063-2.18L3.15 7.302l4.303 4.073 10.392-9.844L18.933.5l2.062 2.18z",
    fill: "#EE4900",
    fillRule: "nonzero"
  })));
}
export default SvgSmallOrangeArrowIcon;